import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { getUiConfigEditorDraftStatus } from '../UiConfigEditor/UiConfigEditorDraftStatus.helper'
import styles from './UiConfigTopbarStatus.module.less'

type Props = {
  isPublished: boolean
  hasDraft: boolean
}

export default function UiConfigTopbarStatus({ isPublished, hasDraft }: Props): ReactElement {
  const { t } = useTranslation()
  const draftStatus = getUiConfigEditorDraftStatus(isPublished, hasDraft)
  const primaryClassName = {
    saved: styles.UiConfigTopbarStatus_Pill__saved,
    published: styles.UiConfigTopbarStatus_Pill__published,
    draft: styles.UiConfigTopbarStatus_Pill__draft,
  }[draftStatus.primaryTone]

  return (
    <div className={styles.UiConfigTopbarStatus}>
      <span className={primaryClassName}>{t(draftStatus.primaryLabel)}</span>
      {draftStatus.secondaryLabel ? (
        <span className={styles.UiConfigTopbarStatus_Pill__draft}>{t(draftStatus.secondaryLabel)}</span>
      ) : null}
    </div>
  )
}
